import type { WorkflowStepCode } from '@exam-management/graphql';
import { Label, LabelColor, type LabelProps } from '@shared/components';

import { QUESTION_REVIEW_STATUS_COLOR, QUESTION_REVIEW_STATUS_TEXT } from './constants';

export interface QuestionReviewStatusTagProps extends LabelProps {
  status: WorkflowStepCode;
}

export default function QuestionReviewStatusTag(props: Readonly<QuestionReviewStatusTagProps>) {
  const { status, ...restProps } = props;

  const statusKey = status as keyof typeof QUESTION_REVIEW_STATUS_COLOR;

  const color = QUESTION_REVIEW_STATUS_COLOR[statusKey] ?? LabelColor.GREY;
  const text = QUESTION_REVIEW_STATUS_TEXT[statusKey] ?? '-';

  return (
    <Label color={color} variant='outlined' {...restProps}>
      {text}
    </Label>
  );
}
